import React, { useEffect, useState } from "react";
import api, { formatApiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { toast } from "sonner";
import { Gift, Copy, WhatsappLogo } from "@phosphor-icons/react";

const STATUS = { converted: ["Assinou · mês grátis creditado", "text-emerald-700 bg-emerald-50"], trial: ["Em teste grátis", "text-amber-700 bg-amber-50"], pending: ["Cadastrado", "text-slate-600 bg-slate-100"] };

export function ReferralCard() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/referrals/me").then((r) => setData(r.data)).catch((e) => toast.error(formatApiError(e))); }, []);
  if (!data) return null;
  const link = `${window.location.origin}/register?ref=${data.code}`;
  const msg = encodeURIComponent(`Oi! Estou usando o O Seu Precificador para precificar meus procedimentos. Cadastre-se pelo meu link e nós dois ganhamos 1 mês grátis: ${link}`);
  const copy = async () => { await navigator.clipboard.writeText(link); toast.success("Link copiado!"); };

  return (
    <div className="card-crisp p-6 bg-gradient-to-br from-indigo-50 to-white border-indigo-100" data-testid="referral-card">
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-lg bg-indigo-600 text-white flex items-center justify-center shrink-0"><Gift size={22} weight="duotone" /></div>
        <div className="flex-1">
          <h3 className="font-heading font-bold text-lg text-slate-900">Indique um colega e ganhe 1 mês grátis</h3>
          <p className="text-sm text-slate-600 mt-1">Quando o colega indicado assinar qualquer plano, <strong>vocês dois</strong> ganham {data.reward_days} dias grátis (crédito automático na próxima fatura).</p>
          <div className="mt-4 flex flex-col sm:flex-row gap-2">
            <code className="flex-1 text-sm bg-white border border-slate-200 rounded-md px-3 py-2 truncate font-mono-nums" data-testid="referral-link">{link}</code>
            <Button variant="outline" onClick={copy} data-testid="referral-copy"><Copy size={16} className="mr-1" /> Copiar</Button>
            <Button asChild className="bg-emerald-600 hover:bg-emerald-700"><a href={`https://wa.me/?text=${msg}`} target="_blank" rel="noreferrer" data-testid="referral-whatsapp"><WhatsappLogo size={16} className="mr-1" /> WhatsApp</a></Button>
          </div>
          <div className="mt-4 flex gap-6 text-sm">
            <div><span className="font-mono-nums font-bold text-slate-900" data-testid="referral-count">{data.referred.length}</span> <span className="text-slate-600">indicado(s)</span></div>
            <div><span className="font-mono-nums font-bold text-slate-900" data-testid="referral-converted">{data.referred.filter((r) => r.status === "converted").length}</span> <span className="text-slate-600">assinaram</span></div>
            <div><span className="font-mono-nums font-bold text-slate-900" data-testid="referral-months">{data.months_earned}</span> <span className="text-slate-600">mês(es) ganho(s)</span></div>
          </div>
          {data.referred.length > 0 && (
            <ul className="mt-3 space-y-1.5">
              {data.referred.map((r, i) => (
                <li key={i} className="flex items-center justify-between text-sm">
                  <span className="text-slate-700">{r.name} · {new Date(r.created_at).toLocaleDateString("pt-BR")}</span>
                  <span className={`text-xs px-2 py-0.5 rounded-full ${STATUS[r.status][1]}`}>{STATUS[r.status][0]}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}
